import { render } from "./MemberServiceShow.vue?vue&type=template&id=759a2312&scoped=true"
import script from "./MemberServiceShow.vue?vue&type=script&lang=js"
export * from "./MemberServiceShow.vue?vue&type=script&lang=js"

import "./MemberServiceShow.vue?vue&type=style&index=0&id=759a2312&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-759a2312"],['__file',"src/views/h5/common/sys/miniProgram/setting/component/MemberServiceShow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "759a2312"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('759a2312', __exports__)) {
    api.reload('759a2312', __exports__)
  }
  
  module.hot.accept("./MemberServiceShow.vue?vue&type=template&id=759a2312&scoped=true", () => {
    api.rerender('759a2312', render)
  })

}


export default __exports__